import type { PutMetricDataCommandInput } from "@aws-sdk/client-cloudwatch";
import { getFridgeId } from "@jidlomat/terminal-core/utils/browser/localStorage";
import { log, logToSentry } from "@jidlomat/terminal-core/utils/logger";
import { Config } from "../configuration/eatSmartConfig";

// Built once, when the first metric is sent, not when the module loads: reading the fridge id can
// prompt for one, which must not happen as a side effect of an import.
let keepAliveMetric: PutMetricDataCommandInput | undefined;

const getKeepAliveMetric = (): PutMetricDataCommandInput => {
	keepAliveMetric ??= {
		Namespace: "TerminalUptimeMonitoring",
		MetricData: [
			{
				MetricName: "Uptime",
				Dimensions: [
					{
						Name: "fridgeId",
						Value: getFridgeId(),
					},
					{
						Name: "environment",
						Value: import.meta.env.MODE,
					},
				],
				Value: 1,
			},
		],
	};
	return keepAliveMetric;
};

export const sendCloudwatchMetric = (sendLogs: boolean) => {
	const metric = getKeepAliveMetric();
	if (sendLogs) {
		fetch(Config.aws.cloudWatchEndpoint, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(metric),
		}).catch((e) => {
			logToSentry("Error sending cloudwatch metric", "error", e);
		});
	} else {
		log("Cloudwatch check", "info", metric);
	}
};
